import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import PersonalStatus from './components/PersonalStatus/';
import './style.css';
import { NEWTUBE_API_SERVER } from 'configs/url';
import { connect } from 'react-redux';
import { fetchUserContent, updateUserContent } from './reducers/contentReducer';
import { updateImg } from './reducers/personalImgReducer';
import { fetchFieldSettings } from './reducers/fieldSettingsReducer';
import { debounce } from 'lodash';
import UploadPersonalImgForm from './components/UploadPersonalImgForm';
import MessageForm from '../../components/MessageForm';
import WindowBox from '../../components/WindowBox';
import { initialize } from './reducers';
import { fetchParams } from './reducers/paramsReducer';
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl';
const messages = defineMessages({
  fileUpdateError: {
    id: 'SH_UploadFailed',
    defaultMessage: '檔案上傳失敗',
  },
});

class MyData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openUploadForm: false,
      personalPicture: `${NEWTUBE_API_SERVER}users/personalPicture`,
      message: '',
    };
    this.onShowUploadForm = this.onShowUploadForm.bind(this);
    this.onCloseUploadForm = this.onCloseUploadForm.bind(this);
    this.onCloseUploadForm = this.onCloseUploadForm.bind(this);
    this.onUploadPersonaImg = this.onUploadPersonaImg.bind(this);
  }

  componentDidMount() {
    this.props.initialize();
    this.props.fetchUserContent();
    this.props.fetchFieldSettings();
    this.props.fetchParams();
  }

  onShowUploadForm(event) {
    event.preventDefault();
    this.setState({
      openUploadForm: true,
    });
  }

  onUploadPersonaImg(values) {
    const formData = new FormData();
    formData.append('Picture', values.picture);
    return this.props.updateImg(formData).then(() => {
      this.setState({ openUploadForm: false });
      // 檔案上傳成功後，直接用上傳的檔案來顯示大頭貼，避免要求Refresh才能更新大頭貼
      const reader = new FileReader();
      reader.onload = function onload(e) {
        this.setState({ personalPicture: e.target.result });
      }.bind(this);
      reader.readAsDataURL(values.picture);
      Promise.resolve();
    }, () => {
      this.setState({ message: this.props.intl.formatMessage(messages.fileUpdateError), openUploadForm: false });
      Promise.reject();
    });
  }

  onCloseUploadForm(event) {
    event.preventDefault();
    this.setState({
      openUploadForm: false,
    });
  }

  renderMessageBox() {
    const message = this.state.message;
    if (message && message.length > 0) {
      return (
        <WindowBox
          title={[<FormattedMessage key="1" id="SH_Message" defaultMessage="訊息"/>]}
          onClose={() => { this.setState({ message: '' }); }} width={250}
        >
          <MessageForm
            MessageText={this.state.message}
            onConfirm={() => { this.setState({ message: '' }); }}
          />
        </WindowBox>
      );
    }
    return '';
  }

  render() {
    return (
      <div className="mydata clearfix">
        {
          this.renderMessageBox()
        }
        {
          this.state.openUploadForm && (
            <UploadPersonalImgForm
              onClose={this.onCloseUploadForm}
              onSubmit={this.onUploadPersonaImg}
            />
          )
        }
        <div className="col-md-3">
          <PersonalStatus
            onFileItemClick={this.onShowUploadForm}
            onContentChange={debounce(this.props.updateUserContent, 500)}
            content={this.props.mydata.content}
            photoImgUrl={ this.state.personalPicture }
          />
        </div>
        <div className="col-md-9 mydata-edit-container">
            <ul className="tab-container">
                <li className="tab">
                  <Link to="/Foundation/mydata/basicinfo" activeClassName="active">
                    <FormattedMessage id="SH_EmpInformation" defaultMessage="基本資料" />
                  </Link>
                </li>
                <li className="tab">
                  <Link to="/Foundation/mydata/contactinfo" activeClassName="active">
                    <FormattedMessage id="SH_ContactInformation" defaultMessage="通訊資料" />
                  </Link>
                </li>
                <li className="tab">
                  <Link to="/Foundation/mydata/certificationandeducationinfo" activeClassName="active">
                    <FormattedMessage id="FD_EducationCertificate" defaultMessage="學歷證照" />
                  </Link>
                </li>
                <li className="tab">
                  <Link to="/Foundation/mydata/workexpinfo" activeClassName="active">
                    <FormattedMessage id="SH_WorkHistory" defaultMessage="工作經歷" />
                  </Link>
                </li>
                <li className="tab">
                  <Link to="/Foundation/mydata/seniorityinfo" activeClassName="active">
                    <FormattedMessage id="FD_ServiceYear" defaultMessage="年資" />
                  </Link>
                </li>
                <li className="tab">
                  <Link to="/Foundation/mydata/jobchangeinfo" activeClassName="active">
                    <FormattedMessage id="SH_AssignmentHistory" defaultMessage="職務經歷" />
                  </Link>
                </li>
            </ul>
            <div className="clearfix">
                { this.props.children }
            </div>
        </div>
      </div>
    );
  }
}

MyData.propTypes = {
  children: PropTypes.object,
  mydata: PropTypes.object,
  fetchUserContent: PropTypes.func.isRequired,
  updateUserContent: PropTypes.func.isRequired,
  updateImg: PropTypes.func.isRequired,
  fetchFieldSettings: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  fetchParams: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

function mapStateToProps(state) {
  return {
    mydata: state.app.foundation.mydata,
  };
}

MyData = connect(mapStateToProps, {
  fetchUserContent,
  updateUserContent,
  updateImg,
  fetchFieldSettings,
  initialize,
  fetchParams,
})(MyData);
export default injectIntl(MyData);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/index.js
 **/